import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

interface ImpersonateTarget {
  label: string;
  path: string;
}

/** Sub-shell for the three impersonation targets within one company. */
@Component({
  selector: 'app-company-impersonate',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet],
  template: `
    <nav class="impersonate-targets" aria-label="Impersonation targets">
      <a
        *ngFor="let target of targets"
        class="impersonate-targets__link"
        [routerLink]="target.path"
        routerLinkActive="is-active"
      >
        {{ target.label }}
      </a>
    </nav>
    <router-outlet></router-outlet>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .impersonate-targets {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        margin-bottom: 1.25rem;
      }
      .impersonate-targets__link {
        padding: 0.45rem 0.85rem;
        border-radius: 999px;
        border: 1px solid var(--border-color, #d1d5db);
        color: inherit;
        text-decoration: none;
        font-size: 0.875rem;
      }
      .impersonate-targets__link.is-active {
        background: #111827;
        border-color: #111827;
        color: #fff;
      }
    `,
  ],
})
export class CompanyImpersonateComponent {
  readonly targets: ImpersonateTarget[] = [
    { label: 'Admin', path: 'admin' },
    { label: 'Staff / Employee', path: 'staff' },
    { label: 'Tunnel', path: 'tunnel' },
  ];
}
